import { Common } from './common';
import { LogBase, Log, FindAllOptions } from './models/log';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options?: FindAllOptions): Promise<Log[]> {
    const url = this.common.constructPath('/log', options);
    const { logs } = await this.common.getJSON(url);
    return logs;
  }

  async create(log: LogBase): Promise<Log> {
    const url = this.common.constructPath('/log');
    return this.common.postJSON(url, log);
  }
}
